import {
    SYSTEM_CHOOSE_CURRENT_EDU,
} from './constants';
  
export function chooseCurrentEdu(modal) {
    return {
      type: SYSTEM_CHOOSE_CURRENT_EDU,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_CHOOSE_CURRENT_EDU:
        return {
          ...state,
          currentEdu:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/system/redux/chooseCurrentEdu.js